module.exports = __webpack_public_path__ + "static/media/left_gain.991648f0.png";